module.exports = {
  siteTitle: 'Mohammad Darandeh',
  siteDescription:
    'Mohammad Darandeh is an incoming Game Developer, based in Iran, who loves learning new things and helping tech beginners.',
  siteKeywords:
    'Mohammad Darandeh, Mohammad, Darandeh, mohammaddarandeh, software engineer, game developer, python, java, fum, mashhad',
  siteUrl: 'https://yashitanamdeo.github.io/',
  siteLanguage: 'en_US',
  googleAnalyticsID: '-',
  googleVerification: '-',
  name: 'Mohammad Darandeh',
  location: 'Mashhad, Iran',
  email: 'm.darandeh99@gmail.com',
  github: 'https://github.com/Voldana',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Voldana',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/mohammaddarandeh',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/mohammad.darandeh/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
